import { type CSSProperties } from "react";

import clsx from "clsx";

export interface SwitchProps {
  size?: "large" | "small" | "medium" | "x-small";
  value: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
  id?: string;
  className?: string;
  labelClassname?: string;
  style?: CSSProperties & { [key: string]: string };
}

export const Switch = ({
  value,
  onChange,
  id,
  disabled = false,
  size = "medium",
  className,
  labelClassname,
  style,
}: SwitchProps) => {
  const htmlId = `check--${id}`;

  const iconClass = disabled
    ? "fa-regular fa-toggle-large-off text-sm text-v2-secondary cursor-pointer"
    : value
    ? "fa-regular fa-toggle-large-on text-sm text-v2-action cursor-pointer"
    : "fa-regular fa-toggle-large-off text-sm text-v2-secondary cursor-pointer";

  return (
    <label
      className={clsx(`custom-switch-${size}`, labelClassname)}
      htmlFor={htmlId}
      style={style}
    >
      <input
        className="hidden"
        disabled={disabled}
        type="checkbox"
        checked={value}
        onChange={({ target }) => onChange(target.checked)}
        id={htmlId}
      />
      <i className={clsx(iconClass, className)} />
    </label>
  );
};
